export enum WarningsPathsEnum {
  ALL_WARNINGS = "/warnings",
  WARNING_DETAILS = "/warnings/:warningId",
}
